// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2152":"bf93ed05","3111":"a781397a","5369":"9f979b53","6090":"e8d1a4ce","6493":"1ae29c75","7650":"efcf5763","8499":"76b5a2b2"}[chunkId] + ".chunk.css";
};